// Translations for FR and EN
export const translations = {
  fr: {
    // Navigation
    nav: {
      monHistoire: "Je suis",
      auxEtresChers: "Hommages",
      services: "Services",
      deroulement: "Déroulement",
      souvenirs: "Souvenirs",
      temoignages: "Témoignages",
      murDuSouvenir: "Mur du Souvenir",
      faq: "FAQ",
      partenaires: "Partenaires",
      blog: "Blog",
      contact: "Contacter un défunt",
      contacterDefunt: "Contacter un défunt",
    },
    
    // Preloader
    preloader: {
      title: "BRICE MÉDIUM",
      subtitle: "Je Parle avec les Défunts",
    },
    
    // Hero Section
    hero: {
      badge: "Médium et Messager",
      titleLine1: "Parler à ceux que",
      titleLine2: "vous aimez,",
      titleHighlight: "là-haut",
      descriptionMobile: "Ils sont toujours près de vous.\nHumains ou animaux,\nje transmets leurs révélations.",
      descriptionDesktop: "Ils sont toujours près de vous. Humains ou animaux, je transmets leurs révélations.",
      ctaButton: "Contacter un défunt",
      freeMinutes: "10 premières minutes gratuites",
      photoLabels: {
        grandfather: "Grand-père",
        grandmother: "Grand-mère",
        mother: "Maman",
        cat: "Minou",
        dog: "Rex",
        friend: "Ami",
      },
    },
    
    // About Section
    about: {
      badge: "Qui Suis-Je",
      titleMobile: "Je suis le pont\nentre deux mondes",
      titleDesktop: "Je suis le pont entre deux mondes",
      letter: {
        intro: "« Il existe des liens que rien ne rompt.\nPas même le temps. Pas même l'absence.",
        question: "Et si ceux que vous aimez avaient encore quelque chose à vous dire ?",
        passeur: "Je suis un simple passeur.\nUn lien entre votre monde et le leur.",
        perceptionMobile: "Depuis l'enfance, je perçois des messages que d'autres n'entendent pas :\ndes mots d'amour, des réponses,\ndes apaisements… parfois des vérités longtemps tues.",
        perceptionDesktop: "Depuis l'enfance, je perçois des messages que d'autres n'entendent pas :\ndes mots d'amour, des réponses, des apaisements… parfois des vérités longtemps tues.",
        defunts: "Défunts, animaux… ils ne disparaissent pas.\nIls restent présents, veillent sur vous et cherchent à entrer en contact.",
        questionsMobile: "Vous avez des questions ?\nBesoin d'un signe, d'un message,\nd'une paix intérieure…\nou peut-être d'un secret à révéler…\nou simplement de comprendre ?",
        questionsDesktop: "Vous avez des questions ?\nBesoin d'un signe, d'un message, d'une paix intérieure…\nou peut-être d'un secret à révéler…\nou simplement de comprendre ?",
        experienceMobile: "Je vous propose une expérience\nconfidentielle, guidée avec exigence,\nsensibilité et respect.",
        experienceDesktop: "Je vous propose une expérience confidentielle,\nguidée avec exigence, sensibilité et respect.",
        moment: "Un moment rare.\nHors du temps.\nEntièrement dédié à vous… et à eux.",
        accompagnement: "Je vous accompagne avec bienveillance pour recevoir ce qu'ils souhaitent vous transmettre.",
        conclusion: "Laissez-moi être leur voix. »",
        signature: "— Brice",
      },
      offer: {
        titleMobile: "10 minutes offertes,\nsans engagement",
        titleDesktop: "10 minutes offertes, sans engagement",
        subtitleMobile: "Commencez votre consultation\nen toute sérénité.",
        subtitleDesktop: "Commencez votre consultation en toute sérénité.",
        point1: "Vous êtes libre d'interrompre la consultation à tout moment durant les 10 premières minutes, sans aucun paiement.",
        point2: "Une fois les dix minutes atteintes, Brice Médium vous indiquera oralement : « Les 10 minutes sont atteintes. Souhaitez-vous poursuivre la consultation ? »",
        footerMobile: "Aucun engagement.\nSimplement une expérience sincère,\nhumaine et transparente.",
        footerDesktop: "Aucun engagement.\nSimplement une expérience sincère,\nhumaine et transparente.",
        disclaimer: "La consultation ne vous sera facturée que si vous choisissez de poursuivre\naprès les 10 minutes offertes.",
      },
      features: {
        humans: "Humains",
        humansDesc: "Besoin d'un message, d'une paix intérieure,\nde savoir enfin.",
        animals: "Animaux",
        animalsDesc: "Communication avec compagnons\ndécédés ou disparus",
        years: "Ans",
        yearsDesc: "D'expérience en médiumnité pur",
      },
      consultations: "consultations réalisées",
      consultationsPrefix: "Plus de",
      souvenirs: {
        titleMobile: "Ils nous ont quittés,\nmais restent vivants",
        titleDesktop: "Ils nous ont quittés, mais restent vivants",
      },
      polaroidCaptions: {
        dad: '"Papa est fier de toi"',
        cat: '"Minou veille sur ta fille"',
        mom: '"Maman t\'envoie du lilas"',
        dog: '"Rex attend tes câlins"',
      },
    },
    
    // Services Section
    services: {
      badge: "Mes Services",
      title: "Comment puis-je vous aider ?",
      subtitle: "Choisissez ce qui résonne avec votre besoin",
      humanConsultation: {
        title: "Consultation Humaine",
        description: "Contact avec un défunt humain. Messages personnels, éléments vérifiables (noms, dates, objets précis), réponses à vos questions.",
        price: "800€",
        note: "10 premières minutes gratuites • Paiement après validation",
      },
      animalCommunication: {
        title: "Communication Animale",
        description: "Votre animal décédé transmet des images, sensations et mots simples. Souvent pour vous rassurer sur leur paix dans l'au-delà.",
        price: "800€",
        note: "10 premières minutes gratuites • Paiement après validation",
      },
    },
    
    // Confidence Banner
    confidence: {
      titleMobile: "Une consultation\nen toute confiance",
      titleDesktop: "Une consultation en toute confiance",
      subtitleMobile: "Chez BRICEMEDIUM.FR,\nla liberté de choisir vous appartient.",
      subtitleDesktop: "Chez BRICEMEDIUM.FR, la liberté de choisir vous appartient.",
      freeMinutes: "Les 10 premières minutes de votre consultation sont entièrement offertes.",
      point1: "Pendant ces 10 minutes, vous pouvez découvrir, ressentir, et",
      point1Bold: "décider librement",
      point2Mobile: "Si vous choisissez d'arrêter,\n",
      point2Desktop: "Si vous choisissez d'arrêter, ",
      point2Bold: "vous ne payez absolument rien",
      point3: "Si vous souhaitez continuer, la consultation se poursuit au tarif de",
      point3Price: "800€",
      footer1: "Aucune pression. Aucun piège.",
      footer2Mobile: "Juste une relation basée\nsur la confiance et la transparence.",
      footer2Desktop: "Juste une relation basée sur la confiance et la transparence.",
    },
    
    // Process Section
    process: {
      badge: "Comment ça fonctionne",
      title: "Le Chemin vers l'Au-delà",
      steps: {
        step1: {
          title: "Prise de RDV",
          description: "Envoyez une demande « Contacter un défunt ». Pas de paiement à l'avance.",
        },
        step2: {
          title: "Connexion Gratuite",
          description: "10 minutes pour établir le contact. L'esprit se manifeste ou non.",
        },
        step3: {
          title: "Validation",
          description: "Je vous donne 1 à 2 détails du défunt. Nous continuons. Sauf...",
          link: "en savoir plus",
        },
        step4: {
          title: "Messages",
          description: "Nous procédons au paiement, puis je vous transmets l'ensemble des informations reçues. Nous les analysons ensuite ensemble afin d'approfondir et d'obtenir davantage de détails sur la personne concernée.",
        },
      },
      infoModal: {
        title: "En savoir plus",
        content: "Sauf si vous désirez arrêter au bout de 10 minutes. Et c'est votre droit. Alors, vous n'aurez rien à payer.",
        button: "J'ai compris",
      },
    },
    
    // Testimonials Section
    testimonials: {
      badge: "Témoignages",
      title: "Désormais en paix,\nils apaisent les cœurs comme les âmes",
      types: {
        human: "Consultation Humaine",
        animal: "Communication Animale",
        family: "Séance Familiale",
      },
      items: [
        {
          text: "Brice a décrit la robe de mariée de ma mère, son parfum, et m'a dit qu'elle était désolée pour notre dispute de 2019. Comment aurait-il pu savoir ?",
          author: "Claire D.",
          type: "human",
        },
        {
          text: "Mon labrador jouait avec sa balle. Brice m'en a décrit la couleur rouge, ainsi que d'autres détails, remplissant mon cœur de joie. Sa disparition me bouleverse tant et me fait monter les larmes aux yeux.",
          author: "Marc T.",
          type: "animal",
        },
        {
          text: 'Mon fils est décédé à 12 ans. Brice a évoqué son doudou lapin et sa peur du noir. Il m\'a dit : "Je ne t\'ai jamais quitté maman". Un cadeau inestimable.',
          author: "Isabelle R.",
          type: "family",
        },
        {
          text: "Ma grand-mère m'a parlé à travers Brice. Elle a mentionné la recette de son gâteau aux pommes et l'endroit où elle cachait ses bijoux. Personne ne le savait.",
          author: "Sophie M.",
          type: "human",
        },
        {
          text: "Mon chat Félix est parti il y a 2 ans. Brice m'a dit qu'il dormait toujours au pied de mon lit. J'ai senti sa présence cette nuit-là. Merci infiniment.",
          author: "Laurent P.",
          type: "animal",
        },
        {
          text: "Mon père n'a jamais dit je t'aime de son vivant. À travers Brice, il l'a enfin dit. Ces mots m'ont libérée d'un poids que je portais depuis 20 ans.",
          author: "Marie-Claire B.",
          type: "human",
        },
        {
          text: "Brice a décrit parfaitement notre maison d'enfance, le jardin, l'arbre où on jouait. Ma sœur décédée voulait que je sache qu'elle veillait sur mes enfants.",
          author: "François L.",
          type: "family",
        },
        {
          text: "Mon cheval Sultan m'a transmis qu'il était en paix et galopait librement. Brice a décrit sa tache blanche sur le front. Je n'avais rien mentionné.",
          author: "Camille R.",
          type: "animal",
        },
        {
          text: "Ma meilleure amie partie trop tôt m'a rappelé notre voyage en Italie et notre promesse. Elle m'a dit de vivre pour nous deux. Je suis en paix maintenant.",
          author: "Nathalie G.",
          type: "human",
        },
        {
          text: "Mon mari m'a révélé où il avait caché notre alliance perdue. Je l'ai retrouvée exactement là où Brice l'avait indiqué. Bouleversant de vérité.",
          author: "Monique D.",
          type: "human",
        },
        {
          text: "Notre perroquet Coco nous manquait terriblement. Brice nous a dit qu'il chantait toujours sa chanson préférée près de nous. Un moment magique.",
          author: "Pierre et Anne V.",
          type: "animal",
        },
        {
          text: "Mon frère jumeau parti trop jeune m'a envoyé un message d'amour. Brice a utilisé notre langage secret que personne d'autre ne connaissait. Extraordinaire.",
          author: "Thomas K.",
          type: "family",
        },
      ],
    },
    
    // Trust Badges
    trustBadges: {
      securePayment: "Paiement sécurisé",
      confidentiality: "Confidentialité garantie",
      satisfaction: "Satisfaction approuvée",
    },
    
    // Try Banner
    tryBanner: {
      title: "Et si vous essayiez…",
      subtitleMobile: "Vous bénéficiez de 10 minutes offertes\npour vous faire votre propre ressenti.",
      subtitleDesktop: "Vous bénéficiez de 10 minutes offertes pour vous faire votre propre ressenti.",
      point1Mobile: "Si cela ne vous convient pas,\nvous arrêtez… et",
      point1Desktop: "Si cela ne vous convient pas, vous arrêtez… et",
      point1Bold: "vous ne payez rien",
      point2Mobile: "Si vous ressentez que la consultation\nvous apporte quelque chose,\nvous pouvez",
      point2Desktop: "Si vous ressentez que la consultation vous apporte quelque chose, vous pouvez",
      point2Bold: "continuer librement",
      footerMobile: "Vous gardez le contrôle,\ndu début à la fin.",
      footerDesktop: "Vous gardez le contrôle, du début à la fin.",
    },
    
    // Memorial Wall
    memorial: {
      badge: "Mur du Souvenir",
      title: "Hommages aux Êtres Chers",
      tagline: "Ils nous ont quittés, mais restent vivants",
      subtitle: "Avec leur accord et celui de leurs familles, ces photos témoignent des moments de connexion et de réconfort partagés lors de nos consultations. Chaque être cher reste présent dans nos cœurs.",
      addPhoto: "Je souhaite ajouter une photo",
      addPhotoDesc: "Si vous souhaitez que votre être cher figure sur ce mur du souvenir, cliquez ci-dessous.",
    },
    
    // Newsletter Section
    newsletter: {
      badge: "Restez Connecté",
      title: "La sagesse des défunts",
      subtitle: "Une fois par mois, recevez quelques précieux témoignages transmis par les défunts,\ndans le respect de leur anonymat, et découvrez l'émotion de renouer le lien\navec ceux qui nous ont quittés.",
      placeholder: "Votre adresse email",
      button: "S'inscrire",
      success: "Merci pour votre inscription !",
      privacy: "Vos données restent confidentielles et ne seront jamais partagées.",
    },
    
    // CTA Section
    cta: {
      title: "Une question brûle\nvos lèvres ?",
      subtitle: "Peut-être qu'un message vous est destiné.",
      button: "Prendre contact",
    },
    
    // Contact Form / Booking Modal
    contact: {
      title: "Contacter un Défunt",
      subtitle: "Les 10 premières minutes sont gratuites",
      prenom: "Prénom",
      email: "Email",
      telephone: "Téléphone (optionnel)",
      departement: "Département",
      selectDepartement: "Sélectionnez votre département",
      ville: "Ville",
      message: "Votre message (facultatif)",
      messagePlaceholder: "Parlez-moi de vous, de la personne que vous souhaitez contacter...",
      send: "Envoyer ma demande",
      sending: "Envoi en cours...",
      success: "Demande envoyée ! Je vous recontacterai très bientôt.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    
    // FAQ
    faq: {
      title: "Questions Fréquentes",
      items: [
        {
          question: "Est-ce que ça fonctionne vraiment ?",
          answer: "Je comprends votre scepticisme. C'est pourquoi je vous offre 10 minutes gratuites pour que vous puissiez juger par vous-même. Je vous donnerai des détails vérifiables que je ne peux pas connaître autrement.",
        },
        {
          question: "Comment se déroule une consultation ?",
          answer: "La consultation se fait par téléphone. Je me connecte à l'énergie de votre défunt et je transmets les messages, images et sensations que je reçois. Vous pouvez poser des questions.",
        },
        {
          question: "Puis-je contacter n'importe quel défunt ?",
          answer: "Je peux tenter d'établir le contact avec tout défunt humain ou animal. Cependant, certains esprits ne souhaitent pas communiquer ou ne sont pas disponibles. Les 10 minutes gratuites vous permettent de vérifier si le contact est possible.",
        },
        {
          question: "Combien de temps dure une consultation ?",
          answer: "Une consultation dure généralement entre 30 et 60 minutes. Les 10 premières minutes sont gratuites. Vous décidez ensuite si vous souhaitez continuer.",
        },
        {
          question: "Que se passe-t-il si le contact n'est pas établi ?",
          answer: "Si aucun contact n'est établi pendant les 10 minutes gratuites, vous ne payez rien. C'est ma garantie de confiance envers vous.",
        },
        {
          question: "Est-ce confidentiel ?",
          answer: "Absolument. Tout ce qui est dit pendant la consultation reste strictement confidentiel. Je suis tenu au secret professionnel.",
        },
        {
          question: "Peut-on contacter plusieurs défunts ?",
          answer: "Oui, lors d'une même consultation, plusieurs défunts peuvent se manifester. Parfois, des proches que vous n'attendiez pas viennent transmettre des messages.",
        },
        {
          question: "Comment régler la consultation ?",
          answer: "Le paiement de 800€ s'effectue après la validation, c'est-à-dire après les 10 minutes gratuites si vous décidez de continuer. Paiement sécurisé par carte bancaire.",
        },
      ],
    },
    
    // Cookie Banner
    cookies: {
      title: "Votre vie privée nous est précieuse",
      description: "Nous utilisons des cookies pour améliorer votre expérience sur notre site.",
      acceptAll: "Tout accepter",
      customize: "Personnaliser",
      refuse: "Continuer sans accepter",
      learnMore: "En savoir plus sur notre",
      privacyPolicy: "politique de confidentialité",
    },
    
    // Footer
    footer: {
      slogan: "Médium et Messager – Guidant les messages entre les mondes depuis plus de 23 ans",
      navigation: "Navigation",
      contact: "Contact",
      legal: "Mentions légales",
      cgv: "Conditions générales de vente",
      cgu: "Conditions générales d'utilisation",
      confidentialite: "Confidentialité",
      conditionsValidation: "Conditions de validation",
      copyright: "Tous droits réservés",
    },
    
    // Modals
    modals: {
      reservation: {
        title: "Réserver une consultation",
        subtitle: "Les 10 premières minutes sont gratuites",
      },
      conditionsValidation: {
        title: "Conditions de validation de la consultation",
        text1: "Je reconnais avoir bénéficié des",
        freeMinutes: "10 minutes gratuites",
        text2: "Je confirme souhaiter poursuivre la consultation au-delà de ces 10 minutes et accepte le paiement de",
        price: "800€",
        text3: "Je reconnais que cette validation constitue un",
        engagement: "engagement ferme et définitif",
        text4: "et qu'aucun remboursement ne pourra être demandé après la réalisation de la prestation.",
        typeConsultation: "Type de consultation :",
        humain: "Une consultation pour une personne",
        animal: "Une consultation pour un animal",
        accept: "J'ai lu et j'accepte les conditions de validation de la consultation",
        payButton: "Procéder au paiement sécurisé",
      },
      partners: {
        title: "Nos Partenaires",
        description: "Nous collaborons avec des professionnels de confiance qui partagent nos valeurs d'authenticité, de bienveillance et de respect.",
        visitSite: "Visiter le site",
        becomePartner: "Vous souhaitez devenir partenaire ?",
        contactUs: "Contactez-nous à",
      },
      addPhoto: {
        title: "Ajouter une photo au Mur du Souvenir",
        prenomDefunt: "Prénom du défunt",
        type: "Type",
        humain: "Humain",
        animal: "Animal",
        photo: "Photo",
        photoFormats: "Formats acceptés : JPEG, PNG, GIF (max 5MB)",
        consent: "Je certifie être un proche du défunt et autorise BRICEMEDIUM.FR à publier cette photo sur le Mur du Souvenir. Je comprends que je peux demander le retrait à tout moment en contactant",
        submit: "Envoyer ma demande",
        successTitle: "Demande envoyée !",
        successMessage: "Vos informations restent strictement confidentielles et ne seront jamais partagées.",
      },
    },
    
    // Common
    common: {
      close: "Fermer",
      cancel: "Annuler",
      save: "Enregistrer",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      backToTop: "Retour en haut",
    },

    // Blog
    blog: {
      heroBadge: "La sagesse de l'au-delà",
      heroTitle1: "Messages, signes et",
      heroTitleEm: "révélations",
      heroSubtitleMobile: "Explorez les mystères de la communication avec\nles défunts. Articles, témoignages et guides\npour comprendre les signes de l'au-delà.",
      heroSubtitleDesktop: "Explorez les mystères de la communication avec les défunts. Articles, témoignages et guides pour comprendre les signes de l'au-delà.",
      sectionTitle: "Articles",
      sectionTitleEm: "à la une",
      sectionSubtitleMobile: "Signes, rêves, messages —\ntout ce que vous devez savoir",
      sectionSubtitleDesktop: "Signes, rêves, messages — tout ce que vous devez savoir",
      ctaTitle1: "Un message vous",
      ctaTitleEm: "attend",
      ctaTitle2: "peut-être ?",
      ctaSubtitle: "10 premières minutes gratuites pour établir le contact. C'est sans engagement.",
      ctaSubtitleShort: "10 premières minutes gratuites pour établir le contact. C'est sans engagement.",
      ctaButton: "Demander un rendez-vous",
      backToBlog: "Retour au blog",
      breadcrumbHome: "Accueil",
      breadcrumbBlog: "Blog",
      authorName: "Brice Médium",
      faqTitle: "Questions",
      faqTitleEm: "fréquentes",
      relatedTitle: "À lire aussi",
      notFoundTitle: "Article introuvable",
      notFoundDesc: "Cet article n'existe pas ou a été déplacé.",
      writingPlaceholder: "« Article en cours de rédaction »",
      writingHint: "À paraître prochainement",
    },
  },
  
  en: {
    // Navigation
    nav: {
      monHistoire: "I am",
      auxEtresChers: "Tributes",
      services: "Services",
      deroulement: "Process",
      souvenirs: "Memories",
      temoignages: "Testimonials",
      murDuSouvenir: "Memorial Wall",
      faq: "FAQ",
      partenaires: "Partners",
      blog: "Blog",
      contact: "Contact a Loved One",
      contacterDefunt: "Contact a Loved One",
    },
    
    // Preloader
    preloader: {
      title: "BRICE MEDIUM",
      subtitle: "I Speak with the Departed",
    },
    
    // Hero Section
    hero: {
      badge: "Medium and Messenger",
      titleLine1: "Talk to those you",
      titleLine2: "love,",
      titleHighlight: "above",
      descriptionMobile: "They are always near you.\nHumans or animals,\nI transmit their revelations.",
      descriptionDesktop: "They are always near you. Humans or animals, I transmit their revelations.",
      ctaButton: "Contact a loved one",
      freeMinutes: "First 10 minutes free",
      photoLabels: {
        grandfather: "Grandfather",
        grandmother: "Grandmother",
        mother: "Mom",
        cat: "Kitty",
        dog: "Rex",
        friend: "Friend",
      },
    },
    
    // About Section
    about: {
      badge: "Who Am I",
      titleMobile: "I am the bridge\nbetween two worlds",
      titleDesktop: "I am the bridge between two worlds",
      letter: {
        intro: "« There are bonds that nothing can break.\nNot even time. Not even absence.",
        question: "What if those you love still had something to tell you?",
        passeur: "I am a simple messenger.\nA link between your world and theirs.",
        perceptionMobile: "Since childhood, I perceive messages that others don't hear:\nwords of love, answers,\ncomfort… sometimes long-hidden truths.",
        perceptionDesktop: "Since childhood, I perceive messages that others don't hear:\nwords of love, answers, comfort… sometimes long-hidden truths.",
        defunts: "The departed, animals… they don't disappear.\nThey remain present, watch over you and seek to make contact.",
        questionsMobile: "Do you have questions?\nNeed a sign, a message,\ninner peace…\nor perhaps a secret to reveal…\nor simply to understand?",
        questionsDesktop: "Do you have questions?\nNeed a sign, a message, inner peace…\nor perhaps a secret to reveal…\nor simply to understand?",
        experienceMobile: "I offer you a confidential\nexperience, guided with rigor,\nsensitivity and respect.",
        experienceDesktop: "I offer you a confidential experience,\nguided with rigor, sensitivity and respect.",
        moment: "A rare moment.\nBeyond time.\nEntirely dedicated to you… and to them.",
        accompagnement: "I accompany you with kindness to receive what they wish to transmit.",
        conclusion: "Let me be their voice. »",
        signature: "— Brice",
      },
      offer: {
        titleMobile: "10 free minutes,\nno commitment",
        titleDesktop: "10 free minutes, no commitment",
        subtitleMobile: "Start your consultation\nwith peace of mind.",
        subtitleDesktop: "Start your consultation with peace of mind.",
        point1: "You are free to interrupt the consultation at any time during the first 10 minutes, without any payment.",
        point2: "Once the ten minutes are reached, Brice Medium will tell you out loud: « The 10 minutes are up. Would you like to continue the consultation? »",
        footerMobile: "No commitment.\nSimply a sincere, human and transparent experience.",
        footerDesktop: "No commitment.\nSimply a sincere, human and transparent experience.",
        disclaimer: "You will only be charged for the consultation if you choose to continue after the 10 free minutes.",
      },
      features: {
        humans: "Humans",
        humansDesc: "Need a message, inner peace, to finally know.",
        animals: "Animals",
        animalsDesc: "Communication with deceased or missing companions",
        years: "Years",
        yearsDesc: "Of pure mediumship experience",
      },
      consultations: "consultations completed",
      consultationsPrefix: "Over",
      souvenirs: {
        titleMobile: "They left us,\nbut remain alive",
        titleDesktop: "They left us, but remain alive",
      },
      polaroidCaptions: {
        dad: '"Dad is proud of you"',
        cat: '"Kitty watches over your daughter"',
        mom: '"Mom sends you lilacs"',
        dog: '"Rex awaits your hugs"',
      },
    },
    
    // Services Section
    services: {
      badge: "My Services",
      title: "How can I help you?",
      subtitle: "Choose what resonates with your need",
      humanConsultation: {
        title: "Human Consultation",
        description: "Contact with a deceased human. Personal messages, verifiable elements (names, dates, specific objects), answers to your questions.",
        price: "€800",
        note: "First 10 minutes free • Payment after validation",
      },
      animalCommunication: {
        title: "Animal Communication",
        description: "Your deceased pet transmits images, sensations and simple words. Often to reassure you about their peace in the afterlife.",
        price: "€800",
        note: "First 10 minutes free • Payment after validation",
      },
    },
    
    // Confidence Banner
    confidence: {
      titleMobile: "A consultation\nin complete confidence",
      titleDesktop: "A consultation in complete confidence",
      subtitleMobile: "At BRICEMEDIUM.FR,\nthe freedom to choose is yours.",
      subtitleDesktop: "At BRICEMEDIUM.FR, the freedom to choose is yours.",
      freeMinutes: "The first 10 minutes of your consultation are completely free.",
      point1: "During these 10 minutes, you can discover, feel, and",
      point1Bold: "decide freely",
      point2Mobile: "If you choose to stop,\n",
      point2Desktop: "If you choose to stop, ",
      point2Bold: "you pay absolutely nothing",
      point3: "If you wish to continue, the consultation continues at the rate of",
      point3Price: "€800",
      footer1: "No pressure. No tricks.",
      footer2Mobile: "Just a relationship based\non trust and transparency.",
      footer2Desktop: "Just a relationship based on trust and transparency.",
    },
    
    // Process Section
    process: {
      badge: "How it works",
      title: "The Path to the Beyond",
      steps: {
        step1: {
          title: "Booking",
          description: "Send a \"Contact a loved one\" request. No upfront payment.",
        },
        step2: {
          title: "Free Connection",
          description: "10 minutes to establish contact. The spirit manifests or not.",
        },
        step3: {
          title: "Validation",
          description: "I give you 1 to 2 details about the deceased. We continue. Unless...",
          link: "learn more",
        },
        step4: {
          title: "Messages",
          description: "We proceed with payment, then I transmit all the information received. We then analyze it together to deepen and get more details about the person concerned.",
        },
      },
      infoModal: {
        title: "Learn more",
        content: "Unless you want to stop after 10 minutes. And that's your right. Then, you won't have to pay anything.",
        button: "I understand",
      },
    },
    
    // Testimonials Section
    testimonials: {
      badge: "Testimonials",
      title: "Now at peace,\nthey soothe hearts and souls",
      types: {
        human: "Human Consultation",
        animal: "Animal Communication",
        family: "Family Session",
      },
      items: [
        {
          text: "Brice described my mother's wedding dress, her perfume, and told me she was sorry for our 2019 argument. How could he have known?",
          author: "Claire D.",
          type: "human",
        },
        {
          text: "My labrador was playing with his ball. Brice described its red color to me, along with other details, filling my heart with joy. His loss upsets me so much and brings tears to my eyes.",
          author: "Marc T.",
          type: "animal",
        },
        {
          text: 'My son passed away at 12. Brice mentioned his bunny stuffed animal and his fear of the dark. He told me: "I never left you, mom". A priceless gift.',
          author: "Isabelle R.",
          type: "family",
        },
        {
          text: "My grandmother spoke to me through Brice. She mentioned her apple pie recipe and where she hid her jewelry. Nobody knew that.",
          author: "Sophie M.",
          type: "human",
        },
        {
          text: "My cat Felix left 2 years ago. Brice told me he still slept at the foot of my bed. I felt his presence that night. Thank you infinitely.",
          author: "Laurent P.",
          type: "animal",
        },
        {
          text: "My father never said I love you when he was alive. Through Brice, he finally said it. Those words freed me from a weight I had carried for 20 years.",
          author: "Marie-Claire B.",
          type: "human",
        },
        {
          text: "Brice perfectly described our childhood home, the garden, the tree where we played. My deceased sister wanted me to know she was watching over my children.",
          author: "François L.",
          type: "family",
        },
        {
          text: "My horse Sultan transmitted that he was at peace and running freely. Brice described his white mark on his forehead. I hadn't mentioned anything.",
          author: "Camille R.",
          type: "animal",
        },
        {
          text: "My best friend who left too soon reminded me of our trip to Italy and our promise. She told me to live for both of us. I am at peace now.",
          author: "Nathalie G.",
          type: "human",
        },
        {
          text: "My husband revealed where he had hidden our lost wedding ring. I found it exactly where Brice indicated. Overwhelmingly true.",
          author: "Monique D.",
          type: "human",
        },
        {
          text: "Our parrot Coco was terribly missed. Brice told us he still sang his favorite song near us. A magical moment.",
          author: "Pierre and Anne V.",
          type: "animal",
        },
        {
          text: "My twin brother who left too young sent me a message of love. Brice used our secret language that no one else knew. Extraordinary.",
          author: "Thomas K.",
          type: "family",
        },
      ],
    },
    
    // Trust Badges
    trustBadges: {
      securePayment: "Secure payment",
      confidentiality: "Guaranteed confidentiality",
      satisfaction: "Approved satisfaction",
    },
    
    // Try Banner
    tryBanner: {
      title: "What if you tried…",
      subtitleMobile: "You get 10 free minutes\nto form your own feeling.",
      subtitleDesktop: "You get 10 free minutes to form your own feeling.",
      point1Mobile: "If it doesn't suit you,\nyou stop… and",
      point1Desktop: "If it doesn't suit you, you stop… and",
      point1Bold: "you pay nothing",
      point2Mobile: "If you feel that the consultation\nbrings you something,\nyou can",
      point2Desktop: "If you feel that the consultation brings you something, you can",
      point2Bold: "continue freely",
      footerMobile: "You stay in control,\nfrom start to finish.",
      footerDesktop: "You stay in control, from start to finish.",
    },
    
    // Memorial Wall
    memorial: {
      badge: "Memorial Wall",
      title: "Tributes to Loved Ones",
      tagline: "They have left us, but they live on",
      subtitle: "With their consent and that of their families, these photos bear witness to the moments of connection and comfort shared during our consultations. Each loved one remains present in our hearts.",
      addPhoto: "I would like to add a photo",
      addPhotoDesc: "If you would like your loved one to be featured on this memorial wall, click below.",
    },
    
    // Newsletter Section
    newsletter: {
      badge: "Stay Connected",
      title: "Wisdom from the departed",
      subtitle: "Once a month, receive messages transmitted by the departed — sometimes delivered directly, sometimes through the stories of those who have reconnected with their lost loved ones.",
      placeholder: "Your email address",
      button: "Subscribe",
      success: "Thank you for subscribing!",
      privacy: "Your data remains confidential and will never be shared.",
    },
    
    // CTA Section
    cta: {
      title: "Is a question burning on your lips?",
      subtitle: "Perhaps a message is meant for you.",
      button: "Get in touch",
    },
    
    // Contact Form / Booking Modal
    contact: {
      title: "Contact a Loved One",
      subtitle: "The first 10 minutes are free",
      prenom: "First Name",
      email: "Email",
      telephone: "Phone (optional)",
      departement: "Department/State",
      selectDepartement: "Select your department",
      ville: "City",
      message: "Your message (optional)",
      messagePlaceholder: "Tell me about yourself, about the person you wish to contact...",
      send: "Send my request",
      sending: "Sending...",
      success: "Request sent! I will contact you very soon.",
      error: "An error occurred. Please try again.",
    },
    
    // FAQ
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          question: "Does it really work?",
          answer: "I understand your skepticism. That's why I offer you 10 free minutes so you can judge for yourself. I will give you verifiable details that I cannot know otherwise.",
        },
        {
          question: "How does a consultation work?",
          answer: "The consultation is done by phone. I connect to the energy of your deceased and I transmit the messages, images and sensations I receive. You can ask questions.",
        },
        {
          question: "Can I contact any deceased?",
          answer: "I can attempt to establish contact with any deceased human or animal. However, some spirits do not wish to communicate or are not available. The 10 free minutes allow you to verify if contact is possible.",
        },
        {
          question: "How long does a consultation last?",
          answer: "A consultation generally lasts between 30 and 60 minutes. The first 10 minutes are free. You then decide if you want to continue.",
        },
        {
          question: "What happens if contact is not established?",
          answer: "If no contact is established during the 10 free minutes, you pay nothing. That's my guarantee of trust to you.",
        },
        {
          question: "Is it confidential?",
          answer: "Absolutely. Everything said during the consultation remains strictly confidential. I am bound by professional secrecy.",
        },
        {
          question: "Can we contact multiple deceased?",
          answer: "Yes, during the same consultation, multiple deceased may manifest. Sometimes, relatives you weren't expecting come to transmit messages.",
        },
        {
          question: "How do I pay for the consultation?",
          answer: "Payment of €800 is made after validation, that is, after the 10 free minutes if you decide to continue. Secure payment by credit card.",
        },
      ],
    },
    
    // Cookie Banner
    cookies: {
      title: "Your privacy matters to us",
      description: "We use cookies to improve your experience on our site.",
      acceptAll: "Accept All",
      customize: "Customize",
      refuse: "Continue without accepting",
      learnMore: "Learn more about our",
      privacyPolicy: "privacy policy",
    },
    
    // Footer
    footer: {
      slogan: "Medium and Messenger – Guiding messages between worlds for over 23 years",
      navigation: "Navigation",
      contact: "Contact",
      legal: "Legal Notice",
      cgv: "Terms of Sale",
      cgu: "Terms of Use",
      confidentialite: "Privacy Policy",
      conditionsValidation: "Validation Terms",
      copyright: "All rights reserved",
    },
    
    // Modals
    modals: {
      reservation: {
        title: "Book a Consultation",
        subtitle: "The first 10 minutes are free",
      },
      conditionsValidation: {
        title: "Consultation Validation Terms",
        text1: "I acknowledge having benefited from the",
        freeMinutes: "10 free minutes",
        text2: "I confirm that I wish to continue the consultation beyond these 10 minutes and accept the payment of",
        price: "€800",
        text3: "I acknowledge that this validation constitutes a",
        engagement: "firm and final commitment",
        text4: "and that no refund may be requested after the service has been provided.",
        typeConsultation: "Type of consultation:",
        humain: "A consultation for a person",
        animal: "A consultation for an animal",
        accept: "I have read and accept the consultation validation terms",
        payButton: "Proceed to Secure Payment",
      },
      partners: {
        title: "Our Partners",
        description: "We collaborate with trusted professionals who share our values of authenticity, kindness, and respect.",
        visitSite: "Visit Website",
        becomePartner: "Would you like to become a partner?",
        contactUs: "Contact us at",
      },
      addPhoto: {
        title: "Add a Photo to the Memorial Wall",
        prenomDefunt: "First name of the deceased",
        type: "Type",
        humain: "Human",
        animal: "Animal",
        photo: "Photo",
        photoFormats: "Accepted formats: JPEG, PNG, GIF (max 5MB)",
        consent: "I certify that I am a close relative of the deceased and authorize BRICEMEDIUM.FR to publish this photo on the Memorial Wall. I understand that I can request removal at any time by contacting",
        submit: "Submit my request",
        successTitle: "Request sent!",
        successMessage: "Your information remains strictly confidential and will never be shared.",
      },
    },
    
    // Common
    common: {
      close: "Close",
      cancel: "Cancel",
      save: "Save",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      backToTop: "Back to top",
    },

    // Blog
    blog: {
      heroBadge: "Wisdom from the beyond",
      heroTitle1: "Messages, signs and",
      heroTitleEm: "revelations",
      heroSubtitleMobile: "Explore the mysteries of communication with\nthe departed. Articles, testimonies and guides\nto understand the signs from beyond.",
      heroSubtitleDesktop: "Explore the mysteries of communication with the departed. Articles, testimonies and guides to understand the signs from beyond.",
      sectionTitle: "Featured",
      sectionTitleEm: "articles",
      sectionSubtitleMobile: "Signs, dreams, messages —\neverything you need to know",
      sectionSubtitleDesktop: "Signs, dreams, messages — everything you need to know",
      ctaTitle1: "A message may be",
      ctaTitleEm: "waiting",
      ctaTitle2: "for you",
      ctaSubtitle: "First 10 minutes free to establish contact. No commitment.",
      ctaSubtitleShort: "First 10 minutes free to establish contact. No commitment.",
      ctaButton: "Book a consultation",
      backToBlog: "Back to blog",
      breadcrumbHome: "Home",
      breadcrumbBlog: "Blog",
      authorName: "Brice Médium",
      faqTitle: "Frequently",
      faqTitleEm: "asked questions",
      relatedTitle: "Read also",
      notFoundTitle: "Article not found",
      notFoundDesc: "This article does not exist or has been moved.",
      writingPlaceholder: "« Article being written »",
      writingHint: "Coming soon",
    },
  },
};

export default translations;
